/**
 * Safe DOM Mutation Patch
 * 
 * Protects React 19 from crashing when external libraries (ECharts, extensions,
 * Google Translate, portals, or concurrent transitions) modify or detach DOM nodes.
 * 
 * Prevents: "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
 */

if (typeof window !== 'undefined' && typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function <T extends Node>(child: T): T {
        if (!child || child.parentNode !== this) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[SafeDOM] Prevented removeChild crash: node is not a child of this parent.', child, this);
            }
            return child;
        }
        return originalRemoveChild.call(this, child) as T;
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[SafeDOM] Prevented insertBefore crash: referenceNode is not a child of this parent.', referenceNode, this);
            }
            return newNode;
        }
        return originalInsertBefore.call(this, newNode, referenceNode) as T;
    };
}

export {};
